import { render, staticRenderFns } from "./presentation.vue?vue&type=template&id=055589ca&scoped=true&"
import script from "./presentation.vue?vue&type=script&lang=js&"
export * from "./presentation.vue?vue&type=script&lang=js&"
import style0 from "./presentation.vue?vue&type=style&index=0&id=055589ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055589ca",
  null
  
)

export default component.exports